import styled from "@emotion/styled";
import { TICKET_TYPE_STRING } from "@src/components/deungi/common/enum";
import { checkDevice } from "@src/components/deungi/common/utils";
import DeungiDropDownCard from "@src/components/deungi/DeungiDropDownCard";
import React, { useState } from "react";

interface ExpertPaymentInfoBoxProps {
    ticketType: TICKET_TYPE_STRING;
    title: string;
}

const ExpertPaymentInfoBox = ({ ticketType, title }: ExpertPaymentInfoBoxProps) => {
    const deviceType = checkDevice();
    const [dropDownInfo, setDropDownInfo] = useState({
        payInfoDeungiToggle: false,
        refundInfoToggle: false,
    });

    const [agent2DropDownInfo, setAgent2DropDownInfo] = useState({
        payInfoDeungiToggle: false,
        refundInfoToggle: false,
    });

    return (
        <>
            <DeungiInfoDropDownBox>
                <DeungiDropDownCard
                    title={`${title} 충전 이용안내`}
                    descriptions={[
                        {
                            id: 1,
                            desc: " 경매대행 전문가 매칭 이용권 사용 시 요청하기를 요청한 시점에 실시간으로 전국의 매수신청대리인에게 푸시가 보내집니다.",
                        },
                        {
                            id: 2,
                            desc: "결제를 통한 이용권, 충전한 이용권의 유효기간은 결제시점을 기준으로 1년입니다.",
                        },
                        {
                            id: 3,
                            desc: " 이용권 자동 환불은 푸시를 보낸 시점으로부터 8시간 내 지원한 매수신청대리인이 없을 경우, 의뢰인이 매칭확정한 전문가가 없이 지원자 모집 마감을 한 경우에만 가능하며, 결제 후 7일 경과 또는 서비스 이용 시에는 환불이 불가능합니다.",
                        },
                        {
                            id: 4,
                            desc: "이용권 충전 취소는 결제 후 7일 내 이용권 미사용 시 가능하며, 결제 후 7일 경과 또는 서비스 이용 시에는 환불이 불가능합니다.",
                        },
                        {
                            id: 5,
                            desc: "충전 취소 및 환불 요청은 ‘내정보>고객센터>자주묻는질문’에서 가능합니다.",
                        },
                        {
                            id: 6,
                            desc: "이용권 사용은 유효기간이 임박한 순으로 먼저 사용됩니다.",
                        },
                        {
                            id: 7,
                            desc: " 비구독 회원의 경우, 회원가입 후 이용권을 구매 해야만 서비스를 이용하실 수 있습니다. ",
                        },
                        {
                            id: 8,
                            desc: " 무료체험 회원의 경우, 이용권을 구매 해야만 서비스를 이용하실 수 있습니다.  ",
                        },
                    ]}
                    active={dropDownInfo.payInfoDeungiToggle}
                    onClick={() =>
                        setDropDownInfo((prev) => {
                            return { ...prev, payInfoDeungiToggle: !dropDownInfo.payInfoDeungiToggle };
                        })
                    }
                />

                {deviceType !== "android" ? (
                    <>
                        <DeungiDropDownCard
                            title="충전 환불/취소 안내"
                            descriptions={[
                                {
                                    id: 1,
                                    desc: "상품은 사용하지 않은 경우에 한 해, 구매 후 7일 이내에 자주묻는질문에서 직접 구매 취소할 수 있습니다.",
                                },
                                {
                                    id: 2,
                                    desc: "구매 후 7일 이내임에도 ‘내정보>고객센터>자주묻는질문>열람권 취소/환불하기’에 '취소 불가' 상태라면 다음 중 하나 이상의 경우에 해당합니다.",
                                },
                                { id: 3, desc: "1) 상품 패키지의 일부를 사용하여서 직접 환불이 불가능한 경우" },
                                { id: 4, desc: "2) Google Play 결제를 통해 구매한 경우" },
                                { id: 5, desc: "3) iOS APP Store 결제를 통해 구매한 경우" },
                                {
                                    id: 6,
                                    desc: "위 경우에 해당하는 결제 건의 구매 취소를 희망할 경우, 유효 기간 내에 고객센터로 문의해 주세요.",
                                },
                                {
                                    id: 7,
                                    desc: "단, iOS APP Store 결제로 구매한 열람권의 구매 취소는 APPLE 고객센터를 통해서만 가능합니다.",
                                },
                                {
                                    id: 8,
                                    desc: "Google Play 결제로 구매한 열람권 는 구매 후 48시간 이내에는 Google Play 고객센터를 통해, 48시간 이후에는 고객센터를 통해 구매 취소할 수 있습니다.",
                                },
                                { id: 9, desc: "구매 취소나 환불 시에는 결제한 수단으로 환불됩니다." },
                                { id: 10, desc: "구독 혜택 등 무료로 지급된 상품은 환불 대상에서 제외됩니다." },
                            ]}
                            active={dropDownInfo.refundInfoToggle}
                            onClick={() =>
                                setDropDownInfo((prev) => ({
                                    ...prev,
                                    refundInfoToggle: !dropDownInfo.refundInfoToggle,
                                }))
                            }
                        />
                        <DeungiInfoBottomBox>
                            <h3>이용 및 환불/취소 안내를 확인 하였으며, 결제에 동의합니다.</h3>
                        </DeungiInfoBottomBox>
                    </>
                ) : (
                    <></>
                )}
            </DeungiInfoDropDownBox>
        </>
    );
};

const DeungiInfoBottomBox = styled.div`
    position: relative;
    height: 300px;

    & > h3 {
        text-align: center;
        font-size: 11px;
        font-weight: 500;
        line-height: 20px;
        color: #3c3c3c;
        background: #f0f0f0;
        padding: 4px;
    }
`;

const DeungiInfoDropDownBox = styled.section`
    margin: 30px auto 10px;

    .dropDownItem {
        background: #fbf8f8;
        margin: 14px;
        padding: 14px;
        border-radius: 14px;

        .title {
            display: flex;
            justify-content: space-between;
            align-items: center;

            & > h3 {
                font-weight: 400;
                font-size: 14px;
                line-height: 24px;
            }
            & > img {
                width: 12px;
                height: 7px;
                transition: all 0.2s ease;

                &.up {
                    transform: rotate(180deg);
                }
            }
        }
        .contents {
            position: relative;
            overflow: hidden;
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            max-height: 0;
            color: #a3a3a3;
            transition: all 0.2s;
            margin-top: 14px;
            padding-inline-start: 2ch;

            &.show {
                animation: dropDown 0.3s forwards;
                overflow: inherit;
            }
            &.hidden {
                animation: dropUp 0.3s forwards;
            }

            & > li {
                list-style-type: disc;
                list-style-position: outside;
            }
            & > li::marker {
            }
        }
        @keyframes dropDown {
            from {
                max-height: 0;
            }
            to {
                max-height: 100vh;
            }
        }
        @keyframes dropUp {
            from {
            }
            to {
                max-height: 0;
            }
        }
    }
`;

export default ExpertPaymentInfoBox;
